<script setup lang="ts">
    import { InputRow, DatePicker } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid grid-cols-1 gap-3">
        <InputRow
            :form="form"
            name="name"
            label="holidays.table.name"
        >
            <Input
                id="name"
                v-model="form.name"
                :placeholder="$t('holidays.table.name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="holiday_date"
            label="holidays.table.date"
        >
            <DatePicker v-model="form.holiday_date" />
        </InputRow>
    </div>
</template>
